import { ProductSearchMaterial } from '../../../../pages/ProductSearch/types';

export const handleProductViewedEvent = (material: ProductSearchMaterial) => {
  if (material != null) {
    window?.analytics?.track('Product Viewed', {
      product_id: material.entityId,
      sku: material.sku,
      category: material.residentialCommercial?.join(', '),
      name: material.name,
      brand: material.manufacturer || material.brand,
      url: window.location.href,
      image_url: material.imageUrl,
    });
  }
  return false;
};
